export const SITE_PAYSEND = 'https://site.paysend.com';
export const REACT_PAYSEND = 'https://react.paysend.com';
export const PAYSEND_URL = 'https://paysend.com';
export const SITE_PAYSEND_API = SITE_PAYSEND + '/api';
export const STRAPI_PAYSEND_API = process.env.STRAPI_PAYSEND_API;
export const LOCALHOST_CLIENT = 'http://localhost:3000';
export const MIDDLEWARE_HOST = process.env.MIDDLEWARE_HOST;

export const AUTH = '/auth';

//no-auth
export const SEND = '/send';
export const REQUEST = '/request';
export const ABOUT = '/about';

export const SECURITY_CHECK_URL = '/j_spring_security_check';

export const LOGIN = '/login';
export const REGISTRATION = '/registration';
export const LOGOUT = '/logout';
export const LANDING_LINK = '/';
export const CONTACTS = '/contacts';
export const BLOG = '/blog';
export const HELP = '/help';
export const HELP_MOBILE = '/help-mobile';
export const BUSINESS_HELP = '/business-help';
export const BUSINESS_HELP_PAYSEND = 'https://businesshelp.paysend.com/hc';
export const HR_LINK = '/hr';
export const BONUS = '/bonus';
export const RULES = '/rules';
export const PARTNERS = '/partners';
export const RESTORE_PASSWORD = '/restorepassword';
export const RESTORE_PASSWORD_ACTION = '/restorepassword.action';
export const BIRTHDAY_CHECK_ACTION = '/birthdaycheck.action';
export const RESET_PASSWORD_ACTION = '/resetpassword.action';
export const SELECT_REGION = '/select-region';
export const GLOBAL_ACCOUNT = '/multicurrency-account';
export const BUSINESS_CONNECT = '/business-connect';
export const BUSINESS_ACQUIRING = '/business/acquiring';
export const APPLE_PAY_PROMO = '/apple-pay';
export const BUSINESS_CONNECT_CONTACTS = '/business-connect/contacts';
export const HELP_INFO_SUPPORTED_COUNTRIES = '/help/info/supported_countries';
export const USA_WE_CONNECT = '/weconnect';
export const GROW = '/grow';
export const GROW_PAY_LATER = '/grow/paylater';
export const GROW_CREDIT_BUILDER = '/grow/credit-builder';

//auth
export const AUTH_SEND = `${AUTH}/send`;
export const AUTH_SEND_PRECHECK = `${AUTH_SEND}/precheque.action`;
export const AUTH_PHONE_CHECK = `${AUTH}/phone.check`;
export const AUTH_CARD_LINK = `${AUTH}/mycards`;
export const AUTH_MY_CARDS_URL = `${AUTH}/mycards`;
export const AUTH_PROFILE = `${AUTH}/profile`;
export const AUTH_INVITE_CODE_PROMO = `${AUTH}/profile/promo-invite-code-intro`;
export const AUTH_MASTERCARD_PROMO = `${AUTH}/promo/mastercard`;
export const AUTH_PAYSYSTEM_CHECK = `${AUTH}/paysystem.check`;
export const AUTH_GLOBAL_CARD_INFO = `${AUTH}/global/card.info`;
export const GET_RECEIPT_URL = `${AUTH}/email.action`;
export const AUTH_CLOSE_MESSAGE_URL = `${AUTH}/message/close.action`;
export const NO_AUTH_CLOSE_MESSAGE_URL = '/message/close.action';
export const AUTH_TERMS_CONFIRM = `${AUTH}/profile/terms/confirm.action`;
export const AUTH_TERMS_MY_ID_CONFIRM = `${AUTH_SEND}/myId/terms/confirm.action`;
export const AUTH_TERMS_LULU_CONFIRM = `${AUTH_SEND}/lulu/terms/confirm.action`;
export const AUTH_GT_DOWNLOAD = `${AUTH}/gt/download`;

export const AUTH_PAY_STATUS = `${AUTH}/pay/status/request`;
export const AUTH_REPORT_PROBLEM = `${AUTH}/report/problem/about/field`;

//chat
export const OFAKIM_SEND_FILE = '/auth/ofakim/sendfile';

//registration
export const REGISTRATION_ACTION = '/registration.action';

//GA
const AUTH_GA = `${AUTH}/ga`;
export const AUTH_GA_CARDS = `${AUTH_GA}/cards`;
export const AUTH_GA_CARD = `${AUTH_GA}/card/`;
export const AUTH_GA_POCKET = `${AUTH_GA}/pocket/`;
export const AUTH_GA_ACCOUNTS = `${AUTH_GA}/accounts`;
export const AUTH_GA_STUB_PAGE = `${AUTH_GA}/stub-page`;
export const AUTH_GA_FREEZE_CARD = `${AUTH_GA}/card/:cardId/freeze`;
export const AUTH_GA_UNFREEZE_CARD = `${AUTH_GA}/card/:cardId/unfreeze`;
export const AUTH_GA_REMOVE_CARD = `${AUTH_GA}/card/:cardId/remove`;
export const AUTH_GA_PAY_STATUS = `${AUTH_GA}/pay/status/request`;
export const AUTH_GA_TERMS_CONFIRM = `${AUTH_GA}/terms/confirm.action`;
export const AUTH_GA_CARDS_ORDER = `${AUTH_GA_CARDS}/order/`;
export const AUTH_GA_CARD_CREATE_PREVIEW = `${AUTH_GA_CARDS}/order/preview`;
export const AUTH_GA_VIRTUAL_CARD_CREATE_PREVIEW = `${AUTH_GA_CARDS}/order/virtual/preview`;
export const AUTH_GA_PLASTIC_CARD_CREATE_PREVIEW = `${AUTH_GA_CARDS}/order/plastic/preview`;
export const AUTH_GA_CARD_ORDER_VIRTUAL = `${AUTH_GA_CARDS}/order/virtual`;
export const AUTH_GA_CARD_ORDER_PLASTIC = `${AUTH_GA_CARDS}/order/plastic`;
export const AUTH_GA_CARD_EXPIRED_NOTIFICATION = `${AUTH_GA_CARD}expired/notification`;
export const AUTH_GA_CARD_ACTIVATE_PLASTIC = `${AUTH_GA_CARD_ORDER_PLASTIC}/activate`;
export const AUTH_GA_HUAWEI_CARD = `${AUTH_GA}/huawei-current-virtual-card`;
export const AUTH_GA_LIBRE_GET_BANKS_INFO = `${AUTH_GA}/libre/get/bank/info`;
export const AUTH_GA_LIBRE_SAVE_BANK = `${AUTH_GA}/libre/choose/bank`;
export const AUTH_GA_LIBRE_SIGN_TERMS = `${AUTH_GA}/libre/sign/terms`;

//KYC
export const INCREASE_GA_LIMIT = `${AUTH}/kyc/ga/limit/intro`;
export const INCREASE_GA_LIMIT_SELECT_COUNTRY = `${AUTH}/kyc/select-user-country`;
export const INCREASE_GT_LIMIT = `${AUTH}/kyc/gt/limit/intro`;
export const KYC_DOCUMENTS_LIST_CANADA = `${AUTH}/kyc/ca`;
export const KYC_MY_ID_UZ = `${AUTH}/kyc/uz`;
export const ADD_EXTRA_MY_ID_UZ = `${AUTH}/profile/uz/extra`;
export const KYC_LULU_AE = `${AUTH}/kyc/ae`;
export const KYC_LULU_AE_CONFIRM = `${AUTH}/kyc/ae/confirm`;
export const INCREASE_GA_LIMIT_ONFIDO_FRAME = `${AUTH}/kyc/ga/onfido/frame`;
export const INCREASE_GT_LIMIT_ONFIDO_FRAME = `${AUTH}/kyc/gt/onfido/frame`;
export const INCREASE_LIMIT_SUMSUB_FRAME = `${AUTH}/kyc/sumsub/frame`;
export const INCREASE_GT_LIMIT_SUMSUB_FRAME = `${AUTH}/kyc/gt/sumsub/frame`;
export const SUMSUB_FRAME_TOKEN = `${AUTH}/kyc/sumsub/frame/token`;
export const KYC_IN_PROGRESS = `${AUTH}/kyc/inprogress`;

//bonus
export const AUTH_BONUS = `${AUTH}${BONUS}`;
export const AUTH_PROFILE_INVITE = `${AUTH_PROFILE}/invite-friends`;
export const AUTH_PROFILE_BONUS = `${AUTH_PROFILE}/bonus`;
export const AUTH_BONUS_WITHDRAW = `${AUTH_PROFILE_BONUS}/withdraw`;
export const AUTH_BONUS_REPEAT = `${AUTH_BONUS}/repeat`;
export const AUTH_GLOBAL_BONUS_WITHDRAW = `${AUTH_PROFILE_BONUS}/global/withdraw`;
export const PROFILE_BONUS_WITHDRAW = `/profile/bonus/withdraw`;
export const AUTH_PROFILE_BONUS_WITHDRAW = `${AUTH_PROFILE_BONUS}/withdraw`;
export const AUTH_BONUS_ABOUT = `${AUTH_BONUS}/about`;

//request
export const AUTH_REQUEST_MAIN_LINK = `${AUTH}${REQUEST}/main.page`;
export const AUTH_REQUEST_CREATE = `${AUTH}${REQUEST}/create`;
export const AUTH_REQUEST_PRECHECK = `${AUTH}${REQUEST}/precheque.action`;
export const AUTH_REQUEST_PAY_PRECHECK = `${AUTH}${REQUEST}/pay/precheque.action`;
export const AUTH_REQUEST_PAY_ACTION = `${AUTH}${REQUEST}/pay.action`;
export const AUTH_REQUEST_SEND_ACTION = `${AUTH}${REQUEST}/send.action`;
export const AUTH_REQUEST_PAY_LINK = `${AUTH}${REQUEST}/pay`;
export const AUTH_REQUEST_CANCEL_LINK = `${AUTH}${REQUEST}/cancel`;
export const AUTH_REQUEST_REPEATE = `${AUTH}${REQUEST}/repeat`;
//request action URL
export const AUTH_REQUEST_CHECK_PHONE = `${AUTH}${REQUEST}/checkCountryByPhone`;
export const AUTH_REQUEST_CHECK_PHONE_NUMBER = `${AUTH}${REQUEST}/checkPhone`;

//send
export const AUTH_CHECK_AVAILABLE_DELIVERY_METHOD = `${AUTH}${SEND}/checkAvailableDeliveryMethod`;
export const AUTH_SEND_REDIRECT_BY_PHONE = `${AUTH}${SEND}/redirectByPhone`;
export const AUTH_SEND_PAY = `${AUTH}${SEND}/pay.action`;
export const AUTH_SEND_MAIN_LINK = `${AUTH}${SEND}/main.page`;
export const AUTH_SEND_LINK = `${AUTH}${SEND}`;
export const AUTH_SEND_REPEAT = `${AUTH}${SEND}/repeat`;
export const AUTH_GLOBAL = `${AUTH}/global`;
export const AUTH_GLOBAL_REPEAT = `${AUTH_GLOBAL}/repeat`;
export const AUTH_SEND_ACCOUNT_DETAILS = `${AUTH}${SEND}/status/account-details`;
export const AUTH_SEND_FROM_INTERAC = `${AUTH}${SEND}/from-interac/`;
export const AUTH_SEND_GET_FIELDS = `${AUTH}/field/container.action`;
export const AUTH_SEND_POST_COUNTRY_SELECT_TERMS = `${AUTH}${SEND}/post/country/select/terms/confirm.action`;
export const AUTH_SEND_BIOMETRIC_TERMS = `${AUTH}${SEND}/biometric/terms/confirm.action`;
export const AUTH_HISTORY_CONFIRM_PLC_TERMS = `${AUTH}${SEND}/plc/country/terms/confirm.action`;
export const AUTH_SEND_FLINK_FRAME = `${AUTH}/send/flink.iframe`;
export const AUTH_SEND_FLINK_ACTION = `${AUTH}/send/flink.action`;
export const AUTH_SEND_PLAID_ACTION = `${AUTH}/send/plaid.action`;
export const AUTH_SEND_PLAID_PAY_CREATE = `${AUTH}${SEND}/plaid/pay.create`;
export const AUTH_SEND_PLAID_SEARCH = `${AUTH}${SEND}/plaid/search`;
export const AUTH_SEND_FLINK_CHECK_STATUS = `${AUTH}/send/flink.checkStatus`;
export const AUTH_SEND_CHANGE_PAYMENT_METHOD = `${AUTH}${SEND}/changePaymentMethod/`;
export const AUTH_SEND_ACH_ANSWERS = `${AUTH}${SEND}/ach/answers.action`;
export const AUTH_SEND_ACH_ADD_ACCOUNT = `${AUTH}${SEND}/add-ach-account.action`;
export const AUTH_PROFILE_ACCOUNT_ACH_ADD_ACCOUNT = `${AUTH}/account/add-ach-account.action`;
export const AUTH_SEND_GET_DC_SOURCES = `${AUTH}${SEND}/get/dc/sources`;
export const AUTH_RECIPIENT_DELETE_ACTION = `${AUTH}/recipient/delete.action`;
export const AUTH_MAIN_ADD_INVITE_CODE = `${AUTH}/invite-code/add`;

//pay
export const AUTH_PAY = `${AUTH}/pay`;
export const AUTH_PAY_MOBILE = `${AUTH_PAY}/mobile`;
export const AUTH_PAY_NOTIFICATION_ACTION = `${AUTH_PAY}/waiting/notification.action`;
export const AUTH_PAYMENTS_HISTORY = `${AUTH}/payments/history/bank-transfer-info`;

//History
export const AUTH_SEARCH_REQUEST = `${AUTH}/request/history`;
export const AUTH_SEARCH_HISTORY = `${AUTH}/payments/history`;
export const RENAME_PAYMENT_URL = `${AUTH}/payments/history/rename.action`;
export const GA_RENAME_PAYMENT_URL = `${AUTH}/ga/payments/history/rename.action`;
export const AUTH_GA_ACCOUNT_HISTORY_PDF = `${AUTH_GA}/history/pdf`;
export const AUTH_GA_CARD_HISTORY_PDF = `${AUTH_GA}/history/card/pdf`;

export const AUTH_CANCEL_TRANSACTION = `${AUTH}/payments/cancel`;

//Card
export const AUTH_CARD_RENAME = `${AUTH}/card/rename.action`;
export const AUTH_CARD_DELETE = `${AUTH}/card/delete.action`;
export const AUTH_BANK_CARD_ADD = `${AUTH}/card/add`;
export const AUTH_BANK_CARD_ADD_ACTION = `${AUTH_BANK_CARD_ADD}.action`;
export const AUTH_PLUM_BANK_CARD_ADD_ACTION = `${AUTH}/plum-card/add.action`;
export const AUTH_BANK_ACCOUNT_ADD = `${AUTH}/account/add`;
export const AUTH_BANK_ACCOUNT_ADD_ACTION = `${AUTH_BANK_ACCOUNT_ADD}.action`;
export const AUTH_CARD_CONFIRM = `${AUTH}/card/confirm`;
export const AUTH_CARD_CANCEL = `${AUTH}/card/confirm/cancel`;

//Profile
export const AUTH_PROFILE_FIELDS = `${AUTH_PROFILE}/fields`;
export const AUTH_PROFILE_FIELDS_UPDATE = `${AUTH_PROFILE_FIELDS}/update.action`;
export const AUTH_PROFILE_SUBSCRIBE_UPDATE = `${AUTH_PROFILE}/subscribe/update.action`;
export const AUTH_PROFILE_PROMO = `${AUTH_PROFILE}/promo`;
export const AUTH_PLUS_MAIN_PAGE = `${AUTH}/plus/main.page`;
export const AUTH_PLUS_UNSUBSCRIBE_SCREEN = `${AUTH}/plus/unsubscribe.screen`;
export const AUTH_PLUS_SUBSCRIBE_UPDATE_SCREEN = `${AUTH}/plus/subscribe/method/update`;
export const AUTH_PLUS_SUBSCRIBE_PLAN_UPDATE_SCREEN = `${AUTH}/plus/subscribe/plan/update`;
export const AUTH_PLUS_UNSUBSCRIBE_ACTION = `${AUTH}/plus/unsubscribe.action`;
export const AUTH_PURPOSE_OF_ACCOUNT_UPDATE_ACTION = `${AUTH}/kyc/purpose-of-account/update.action`;
export const AUTH_PLUS_PAYMENT_METHODS_LIST = `${AUTH}/plus/payment/methods/list`;
export const AUTH_PLUS_EMPLOYEE_SUBSCRIBE = `${AUTH}/plus/employee/subscribe`;
export const AUTH_PLUS_SUBSCRIBE_ACTION = `${AUTH}/plus/subscribe.action`;
export const AUTH_PLUS_PLAN_UPDATE_ACTION = `${AUTH}/plus/plan/update.action`;
export const AUTH_PLUS_RENEW_SUBSCRIBE_ACTION = `${AUTH}/plus/renew-subscribe.action`;
export const AUTH_PLUS_UPDATE_SUBSCRIBE_ACTION = `${AUTH}/plus/subscribe/method/update.action`;
export const AUTH_PROFILE_DOWNLOAD = `${AUTH_PROFILE}/download`;
export const AUTH_PROFILE_AML_LEVELS = `${AUTH_PROFILE}/aml/levels`;
export const AUTH_PROFILE_AML_LEVEL = `${AUTH_PROFILE}/aml/level`;
export const AUTH_PROFILE_GA_AML_LEVEL = `${AUTH_PROFILE}/ga/aml/level`;
export const AUTH_PROFILE_GT_AML_LEVEL = `${AUTH_PROFILE}/gt/aml/level`;
export const AUTH_PROFILE_GA_LIMITS = `${AUTH_PROFILE}/ga/limits`;
export const AUTH_PROFILE_LIMITS = `${AUTH_PROFILE}/limits`;
export const AUTH_PROFILE_LIMIT_INFO = `${AUTH_PROFILE}/limit/info`;
export const AUTH_PROFILE_CHANGE_PHONE = `${AUTH_PROFILE}/change/phone`;
export const AUTH_PROFILE_CHANGE_PHONE_ACTION = `${AUTH_PROFILE}/change/phone.action`;
export const AUTH_PROFILE_CHANGE_EMAIL_ACTION = `${AUTH_PROFILE}/change/email.action`;
export const AUTH_PROFILE_CHANGE_US_OCCUPATION_ACTION = `${AUTH_PROFILE}/change/us_occupation.action`;
export const AUTH_PROFILE_PHONE_UPDATED = `${AUTH_PROFILE}/phone/updated`;
export const AUTH_PROFILE_EDIT_PROFILE = `${AUTH_PROFILE}/fields/screens`;
export const AUTH_PROFILE_PERSONAL_FIELDS_SAVE = `${AUTH_PROFILE}/personal/fields/save.action`;
export const AUTH_SECURITY = `${AUTH}/security`;
export const AUTH_APPEARANCE = `${AUTH_PROFILE}/appearance`;
export const AUTH_SECURITY_DEACTIVATE_ACCOUNT = `${AUTH}/security/deactivate/account`;
export const AUTH_SECURITY_DEACTIVATE_ACCOUNT_ACTION = `${AUTH_SECURITY_DEACTIVATE_ACCOUNT}.action`;
export const AUTH_SETTINGS = `${AUTH}/settings`;
export const AUTH_RESET_PASSWORD_ACTION = `${AUTH_PROFILE}${RESET_PASSWORD_ACTION}`;
export const AUTH_CHANGE_PASSWORD = `${AUTH}/changepassword`;
export const AUTH_CHANGE_PASSWORD_ACTION = `${AUTH_CHANGE_PASSWORD}.action`;
export const AUTH_PROFILE_NOTIFICATION = `${AUTH_PROFILE}/notifications`;
export const AUTH_PROFILE_CHANGE_EMAIL = `${AUTH_PROFILE}/change/email`;
export const AUTH_PROFILE_UPDATE_LEGACY_INFO = `${AUTH_PROFILE}/update-legacy-info`;
export const AUTH_PROFILE_TERMS = `${AUTH_PROFILE}/terms`;
export const AUTH_PROFILE_SETTINGS = `${AUTH_PROFILE}/settings`;
export const AUTH_PROFILE_SSN = `${AUTH_PROFILE}/aml/level/ssn/accept/doc.action`;
export const AUTH_PROFILE_STATEMENT_EMAIL_ACTION = `${AUTH_PROFILE}/statement/email.action`;
export const AUTH_PROFILE_REGISTRATION_FINISH = `${AUTH_PROFILE}/registration/finish`;

//email
export const AUTH_EMAIL_CONFIRM_PREVIEW = `${AUTH}/email/confirm/preview`;
export const AUTH_EMAIL_CONFIRM_ACTION = `${AUTH}/email/confirm/current/email.action`;
export const AUTH_EMAIL_CHECK_INBOX_PAGE = `${AUTH}/email/check/inbox/preview`;
export const EMAIL_UNSUBSCRIBE = '/email/unsubscribe';
export const EMAIL_UNSUBSCRIBE_CONFIRM = '/email/unsubscribe/confirm/';
export const EMAIL_CONFIRM = '/email/confirm/';
export const AUTH_EMAIL_GA_CONFIRM_PREVIEW = `${AUTH_GA}/email/confirm/preview`;

//External
export const WORKABLE = '//apply.workable.com/paysend/';
export const WIDGET_TRUSTPILOT_BOOTSTRAP = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
export const WIDGET_TRUSTPILOT =
    'https://widget.trustpilot.com/trustboxes/53aa8912dec7e10d38f59f36/index.html?businessunitId=59295ddd0000ff0005a34b26&amp;templateId=53aa8912dec7e10d38f59f36#schemaType=Organization&amp;stars=5&amp;theme=light&amp;styleWidth=100%25&amp;styleHeight=250px&amp;tags=ru&amp;locale=ru';
export const CLOUD_FLARE_VERIFICATION = '/api/api-client-verification';
export const TEAMTAILOR = 'https://scripts.teamtailor-cdn.com/widgets/eu-pink/jobs.js';
export const FILLOUT = 'https://server.fillout.com/embed/v1/';
export const APPSFLYER_SMART_SCRIPT = 'https://onelinksmartscript.appsflyer.com/onelink-smart-script-latest.js';

// Links
export const CLIENT_SIGN_IN = 'https://business.paysend.com/sign-in';
export const CLIENT_SIGN_UP = 'https://business.paysend.com/user/sign-up';
export const BC_GOOGLE_DOCS = 'https://business.paysend.com/';
export const BLOG_ARTICLE_GREAT_APP = '/blog/article-great-app-info';
export const GROW_ITUNES_APPLE = 'https://apps.apple.com/GB/app/id1140130413?mt=8';
export const GROW_GOOGLE_PLAY = 'https://play.google.com/store/apps/details?id=com.paysend.app';
export const GROW_HUAWEI = 'https://appgallery.huawei.com/#/app/C102650429';
export const APPLE_STORE_GREAT_APP = 'https://apps.apple.com/app/money-transfer-app-paysend/id1140130413';
export const PLAID = 'https://plaid.com/how-it-works-for-consumers/';
export const PLAID_LINK_CDN = 'https://cdn.plaid.com/link/v2/stable/link-initialize.js';
export const PLAID_LINK_CDN_REMOVE = 'https://cdn.plaid.com/link/';
export const MY_ID_KYC_URL_DEV = 'https://myid.uz/api/v1/oauth2/authorization';
export const MY_ID_KYC_URL_PROD = 'https://myid.uz/api/v1/oauth2/authorization';

// Images
export const URL_CLOUD = 'https://cloud.paysend.com';
export const URL_IMAGES_BANKS = 'https://cloud.paysend.com/images/web/banks';
export const URL_IMAGES_APPS = 'https://cloud.paysend.com/images/web/apps-illustration';
export const URL_IMAGES_I = 'https://cloud.paysend.com/images/web/i';
export const URL_IMAGES_ICONS = 'https://cloud.paysend.com/images/web/icons';
export const URL_IMAGES_PAYSYSTEMS = 'https://cloud.paysend.com/images/web/paysystems';
export const URL_IMAGES_FLAG = 'https://cloud.paysend.com/images/web/flag-icons';
export const URL_IMAGES_FAVICON_NEW = 'https://cloud.paysend.com/images/web/favicon-new';
export const URL_PLACEHOLDER = 'https://cloud.paysend.com/images/web/placeholder';
export const URL_CITY = 'https://cloud.paysend.com/images/web/bg-overlay';
export const URL_SOCIAL_LINKS = 'https://cloud.paysend.com/images/web/social-links';
export const URL_IMAGES_CURRENCIES = 'https://cloud.paysend.com/images/web/currencies';
export const URL_IMAGES_PAYSEND_PLUS = 'https://cloud.paysend.com/images/web/paysend-plus';
export const DEFAULT_CURRENCY_ICON = `${URL_IMAGES_CURRENCIES}/currency-default.svg`;

// antifraud

export const AUTH_ANTIFRAUD = `/auth/antifraud`;
export const AUTH_ANTIFRAUD_HSJ_FIELD_ACTION = `${AUTH_ANTIFRAUD}/fields/send/`;
export const AUTH_ANTIFRAUD_CVV_FIELD_ACTION = `${AUTH_ANTIFRAUD}/check/cvv/send/`;
export const AUTH_ANTIFRAUD_AMOUNT_FIELD_ACTION = `${AUTH_ANTIFRAUD}/send/amount/verification/`;
export const AUTH_ANTIFRAUD_HSJ_FIELD = `${AUTH_ANTIFRAUD}/purpose/transfer`;

// Incomplete transfer
export const AUTH_SEND_INCOMPLETE_PAYMENT_CONTINUE_ACTION = '/auth/send/incomplete/payment/continue.action';
export const AUTH_INCOMPLETE_PAYMENT_INFO = '/auth/incomplete/payment/info';
export const AUTH_SEND_INCOMPLETE_PAYMENT_CALCULATOR_ACTION = '/auth/send/incomplete/payment/calculator.action';

// Deeplinks
export const DL_EMAIL_CONFIRM_REDIRECT = '/dl/email_confirm_redirect';
